<template>
  <div class="col-12">
    <vue-headful :title="`Manifests • ${this.appName}`" />
    <h1>Manifests</h1>
    <div :class="$style.container">
      <div class="row">
        <calendar-view
          :items="calendarItems"
          :show-date="showDate"
          :enable-date-selection="true"
          :selection-start="selectionStart"
          :selection-end="selectionEnd"
          :enable-drag-drop="true"
          @date-selection="dateSelection"
          @date-selection-finish="dateSelectionEnd"
          @click-date="clickedDate"
          @click-item="editManifest"
          @drop-on-date="movedManifest"
          class="theme-default holiday-us-traditional holiday-us-official"
          :class="$style.calendar">
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate" />
        </calendar-view>
      </div>
    </div>
    <new-manifest
      v-if="showNewManifestModal"
      :show="showNewManifestModal"
      :departure-date="selectionStart"
      :arrival-date="selectionEnd"
      @update:show="showNewManifestModal = $event;" />
    <edit-manifest
      v-if="showEditManifestModal"
      :show="showEditManifestModal"
      :manifest-id="selectedManifestID"
      @update:show="showEditManifestModal = $event;" />
  </div>
</template>
<script>
import moment from 'moment-timezone';

import { CalendarView, CalendarViewHeader, CalendarMathMixin } from 'vue-simple-calendar';
import { DatePicker } from 'element-ui';
import NewManifest from 'src/modules/Manifest/NewManifest';
import EditManifest from 'src/modules/Manifest/EditManifest';

require('vue-simple-calendar/static/css/default.css');
require('vue-simple-calendar/static/css/holidays-us.css');

export default {
  name: 'Manifests',
  components: {
    CalendarView,
    CalendarViewHeader,
    NewManifest,
    EditManifest,
    [DatePicker.name]: DatePicker,
  },
  mixins: [CalendarMathMixin],
  props: {
    manifests: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showDate: new Date(),
      selectionStart: null,
      selectionEnd: null,
      selectedManifestID: null,
      showNewManifestModal: false,
      showEditManifestModal: false,
    };
  },
  computed: {
    calendarItems() {
      return this.manifests
        .map(manifest => ({
          id: manifest.id,
          title: `${manifest.jobName}`,
          startDate: manifest.departureDate,
          endDate: manifest.arrivalDate,
          classes: this.classesForManifest(manifest),
        }));
    },
  },
  methods: {
    classesForManifest(manifest) {
      const styles = [];
      if (manifest.status === 'open') {
        styles.push(this.$style.open);
      } else if (manifest.status === 'in_progress') {
        styles.push(this.$style.in_progress);
      } else {
        styles.push(this.$style.closed);
      }

      return styles;
    },
    isToDateSelectionInvalid(date) {
      return date < new Date(this.manifest.from_date);
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('M/DD/YY');
      }
      return '--';
    },
    setShowDate(date) {
      this.showDate = date;
    },
    dateSelection([start, end]) {
      this.selectionStart = start;
      this.selectionEnd = end;
    },
    dateSelectionEnd() {
      this.showNewManifestModal = true;
    },
    resetCalendarDateSelection() {
      this.selectionStart = null;
      this.selectionEnd = null;
    },
    movedManifest(manifest, date) {
      // Determine the delta between the old start date and the date chosen,
      // and apply that delta to both the start and end date to move the item.
      const eLength = this.dayDiff(manifest.startDate, date);
      const newStartDate = this.addDays(manifest.startDate, eLength);
      const newEndDate = this.addDays(manifest.endDate, eLength);

      this.$emit('updateManifest', { id: manifest.id, departureDate: newStartDate, arrivalDate: newEndDate });
    },
    clickedDate(date) {
      this.showNewManifestModal = true;
      this.selectionStart = date;
      this.selectionEnd = date;
    },
    editManifest(manifest) {
      this.selectedManifestID = manifest.id;
      this.showEditManifestModal = true;
    },
  },
  watch: {
    showNewManifestModal(show) {
      if (!show) {
        this.resetCalendarDateSelection();
      }
    },
  },
};
</script>

<style module lang="scss">
@import 'assets/sass/dashboard/custom/_manifests.scss';
.calendar .open {
  background: $open;
  color: white;
}
.calendar .in_progress {
  background: $in-progress;
  color: white;
}
.calendar .closed {
  background: $closed;
  color: white;
}
.calendar {
  min-height: 780px!important;
}
.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.form label {
  display: block;
}
.form > div {
  margin-bottom: 20px;
}
.bookingTitle {
  font-size: 1.3rem
}
.legend {
  display: flex;
}
.item {
  display: flex;
  padding-right: 20px;
}
.colorBox {
  width: 20px;
  height: 20px;
  display: inline-flex;
  margin-right: 10px;
  border: 1px solid gray;
}
</style>
